import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-calibration-update-modal',
  templateUrl: './calibration-update-modal.component.html',
  styleUrls: ['./calibration-update-modal.component.scss']
})
export class CalibrationUpdateModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<CalibrationUpdateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

}
